import React from 'react';
import { ToolComponentProps } from './types';
import { cn } from '../../../lib/utils';

export const DefaultTool: React.FC<ToolComponentProps> = ({ 
  toolName, 
  input, 
  output, 
  isError,
  isExpanded,
  onToggle
}) => {
  return (
    <div className="space-y-2">
      <div className="font-semibold">
        Tool: {toolName}
      </div>

      {input && (
        <div className="p-2 bg-background/50 rounded">
          <div className="font-semibold mb-1">Input:</div>
          <pre className="overflow-x-auto">
            {JSON.stringify(input, null, 2)}
          </pre>
        </div>
      )}

      {output && (
        <div className={cn(
          "p-2 rounded",
          isError ? "bg-destructive/10 text-destructive" : "bg-background/50"
        )}>
          <div className="font-semibold mb-1">
            {isError ? "Error:" : "Output:"}
          </div>
          <div className="whitespace-pre-wrap">
            {typeof output === 'string' ? output : JSON.stringify(output, null, 2)}
          </div>
        </div>
      )}
    </div>
  );
};